import BaseModelAPI from '../BaseModelAPI';

export default class FinishGoodQualityInspectInboxList extends BaseModelAPI {

	static entity = 'finishgoodqualityinspectinboxlist'
	static entityName = 'finishgoodqualityinspectinbox';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
